import { IDataContainerService } from 'app/interfaces/data-container.interface';

/** Campi dell'assistente AI: solo se il modulo è attivo sul dominio selezionato. */
export function skipIfAiAssistantDisabled(record: any, dataContainerService: IDataContainerService): boolean{
	return dataContainerService.getDomainSetting('enabled_modules.ai_assistant.enabled') != true;
}

/** Modifica dell'abilitazione per utente: solo amministratori del dominio (il server lo verifica comunque). */
export function skipIfCannotManageAiAssistant(record: any, dataContainerService: IDataContainerService): boolean{
	return skipIfAiAssistantDisabled(record, dataContainerService)
		|| dataContainerService.getDomainSetting('interface_settings.is_domain_admin') != true;
}
